import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "elevate-analytics-page" }
const _hoisted_2 = { class: "info-filter-container" }
const _hoisted_3 = { class: "filter-row" }
const _hoisted_4 = { class: "filter-item" }
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "table-container" }
const _hoisted_7 = { class: "results-table" }

import { useRouter } from 'vue-router';

import { getPassLine, getUpDownDetailAnalysis } from '@/servers/api/analysis'
import { getGradeApi } from '@/servers/api/grade';
import { getStudentExamApi } from '@/servers/api/student';
import { getSubjectScore } from '@/utils/subjects';
import { ref, onMounted, computed, watch } from 'vue';
import { Button as AButton, Table as ATable, Card as ACard } from 'ant-design-vue';
import type { ColumnType } from 'ant-design-vue/es/table';
import VChart from 'vue-echarts';
import { useUserStore } from '@/store';
import api from '@/servers/api';

interface Exam {
    id:string,
    name:string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ElevateAnalyticsPage',
  setup(__props) {

const router = useRouter();

const userStore = useUserStore();

console.log('User store info at component setup:', userStore.userInfo);
const messageReturn = ref<any[]>([])
// 5. 获取班级、学期、学生
onMounted(async () => {
  // 从localStorage中获取用户信息
  const userString = localStorage.getItem('user');
  if (!userString) {
    console.error('localStorage中没有找到用户信息。');
    messageReturn.value = [];
    return;
  }
  let userInfo: any;
  try {
    userInfo = JSON.parse(userString);
  } catch (e) {
    console.error('解析用户信息失败:', e);
    messageReturn.value = [];
    return;
  }

  if (!userInfo || !userInfo.role) {
    console.error('用户信息不完整或角色ID缺失。', userInfo);
    messageReturn.value = [];
    return;
  }

  const studentId = parseInt(userInfo.role);
  if (isNaN(studentId)) {
    console.error('学生ID无效:', userInfo.role);
    messageReturn.value = [];
    return;
  }

  // 查询学生近几次考试的成绩
  try {
    console.log('调用 getUpDownDetailAnalysis, student_id:', studentId);
    const recent_result = await getUpDownDetailAnalysis({'student_id':studentId,'nums':9999})
    console.log('getUpDownDetailAnalysis 响应:', recent_result);

    if (!recent_result || !recent_result.data) {
      console.warn('getUpDownDetailAnalysis did not return any data or returned null/undefined.');
      messageReturn.value = []; // Initialize to empty array if no data
      return;
    }
    messageReturn.value = recent_result.data;
    //generateTable(recent_result.data,fieldMappingScore);
  } catch (error) {
    console.error('获取学生近期考试成绩失败:', error);
    messageReturn.value = []; // Ensure messageReturn is empty on error
  }
})
const examList = ref<Exam[]>([])
const currentExamId = ref<string>()
onMounted(() => {


    if (!userStore.isLogin) {
        router.push('/user/login');
        return
    }

    const userInfo = userStore.getUserInfo();
    

    getStudentExamApi({student_uid:userInfo.role},[]).then(res => {
        examList.value = res.data.map((item: Exam[]) => ({
            id: item[0].id,
            name: item[0].name
        }));
        
        // 默认选择第一个考试
        currentExamId.value = examList.value[0].id;
        // 获取考试成绩
        getGradeApi({student_id:userInfo.role,exam_id:parseInt(currentExamId.value)}).then(res => {
            const gradeData = res.data[0];
            handleGradeDetail(gradeData)
        })
    })
})

const selectedExamScore = ref<Record<string, number>>({});
const allExamScores = ref<any[]>([]); // 保存所有考试成绩

const baseSubjects = ['总分', '语文', '数学', '英语'];
const scienceSubjects = ['物理', '化学', '生物'];
const artsSubjects = ['政治', '历史', '地理'];
const currentSubjects = ref<string[]>(baseSubjects);

function handleGradeDetail(gradeData: any) {
  // 判断文理科（subjects 对象中存在该科目即视为已选）
  const hasSubject = (cn: string) => gradeData?.subjects?.[cn] != null;
  if (hasSubject('物理') || hasSubject('化学') || hasSubject('生物')) {
    currentSubjects.value = [...baseSubjects, ...scienceSubjects];
  } else if (hasSubject('政治') || hasSubject('历史') || hasSubject('地理')) {
    currentSubjects.value = [...baseSubjects, ...artsSubjects];
  } else {
    currentSubjects.value = baseSubjects;
  }
  selectedExamScore.value = {};
  currentSubjects.value.forEach(sub => {
    selectedExamScore.value[sub] = getSubjectScore(gradeData, sub) ?? 0;
  });
}

// 获取所有考试成绩
function fetchAllExamScores(studentId: number) {
  const promises = examList.value.map(exam =>
    getGradeApi({ student_id: studentId, exam_id: parseInt(exam.id) })
      .then(res => ({ examId: Number(exam.id), examName: exam.name, grade: res.data[0] }))
  );
  Promise.all(promises).then(results => {
    allExamScores.value = results;
  });
}

// 监听考试列表和登录状态，拉取所有考试成绩
watch([examList, userStore], ([newExamList, newUserStore]) => {
  if (examList.value.length && userStore.isLogin) {
    const userInfo = userStore.getUserInfo();
    fetchAllExamScores(Number(userInfo.role));
  }
}, { immediate: true });

const compareExamHeaders = computed(() => {
  return allExamScores.value.filter(e => e.examId !== Number(currentExamId.value)).map(e => e.examName);
});
const compareExamDiffs = computed(() => {
  const base = allExamScores.value.find(e => e.examId === Number(currentExamId.value))?.grade || {};
  return allExamScores.value.filter(e => e.examId !== Number(currentExamId.value)).map(e => {
    const diff: Record<string, number> = {};
    currentSubjects.value.forEach(sub => {
      diff[sub] = (getSubjectScore(e.grade, sub) ?? 0) - (getSubjectScore(base, sub) ?? 0);
    });
    return diff;
  });
});
const baseExamScore = computed(() => {
  const base = allExamScores.value.find(e => e.examId === Number(currentExamId.value))?.grade || {};
  const result: Record<string, number> = {};
  currentSubjects.value.forEach(sub => {
    result[sub] = getSubjectScore(base, sub) ?? 0;
  });
  return result;
});

const goBack = () => {
  // Assuming the previous page is analysis page, adjust if needed
  router.push('/analysis');
};

const currentExamName = computed(() => {
  const exam = examList.value.find(e => e.id === currentExamId.value);
  return exam ? exam.name : '';
});

const allExamScoresMap = computed(() => {
  // 以 currentSubjects 为主，生成每场考试每科的分数
  return allExamScores.value.map(e => {
    const row: Record<string, number> = {};
    currentSubjects.value.forEach(sub => {
      row[sub] = getSubjectScore(e.grade, sub) ?? 0;
    });
    return {
      examId: e.examId,
      examName: e.examName,
      scores: row
    };
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "back-button",
      onClick: goBack
    }, "返回"),
    _cache[6] || (_cache[6] = _createElementVNode("h2", null, "进退步对比", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[2] || (_cache[2] = _createElementVNode("span", { class: "label" }, "考试", -1)),
          _withDirectives(_createElementVNode("select", {
            class: "filter-select",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentExamId).value = $event))
          }, [
            _cache[1] || (_cache[1] = _createElementVNode("option", { value: "" }, "请选择考试", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(examList.value, (exam) => {
              return (_openBlock(), _createElementBlock("option", {
                key: exam.id,
                value: exam.id
              }, _toDisplayString(exam.name), 9, _hoisted_5))
            }), 128))
          ], 512), [
            [_vModelSelect, currentExamId.value]
          ])
        ])
      ]),
      _cache[3] || (_cache[3] = _createElementVNode("p", { class: "description" }, " 说明：需要有两场考试成绩才能进行对比，默认基准考试选择上一次考试，对比本学期所有考试成绩，您也可以选择其他基准考试，其他学期进行学生成绩对比。 ", -1)),
      _cache[4] || (_cache[4] = _createElementVNode("p", { class: "description" }, "说明：第一列为基准考试段次，后续列数红色表较基准考试退步的段次名次，绿色表明较基准进步的段次名次。", -1))
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("table", _hoisted_7, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _cache[5] || (_cache[5] = _createElementVNode("th", null, "学科/考试", -1)),
            _createElementVNode("th", null, _toDisplayString(currentExamName.value), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(compareExamHeaders.value, (header) => {
              return (_openBlock(), _createElementBlock("th", { key: header }, _toDisplayString(header), 1))
            }), 128))
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentSubjects.value, (subject) => {
            return (_openBlock(), _createElementBlock("tr", { key: subject }, [
              _createElementVNode("td", null, _toDisplayString(subject), 1),
              _createElementVNode("td", null, _toDisplayString(baseExamScore.value[subject]), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(compareExamDiffs.value, (diff, i) => {
                return (_openBlock(), _createElementBlock("td", { key: i }, [
                  _createElementVNode("span", {
                    class: _normalizeClass({ red: diff[subject] < 0, green: diff[subject] > 0 })
                  }, _toDisplayString(diff[subject] > 0 ? '+' : '') + _toDisplayString(diff[subject]), 3)
                ]))
              }), 128))
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}
}

})